<template>
  <div class="order-status-page">
    <h1>Suivi de mes commandes</h1>

    <div v-if="loading">Chargement...</div>

    <div v-else>
      <div class="filter-section">
        <label for="statusFilter">Filtrer par statut :</label>
        <select v-model="selectedStatus" id="statusFilter"  class="status-filter">
          <option value="">Tous</option>
          <option value="En attente">En attente</option>
          <option value="Confirmée">Confirmée</option>
          <option value="Expédiée">Expédiée</option>
          <option value="Livrée">Livrée</option>
        </select>
      </div>

      <table v-if="paginatedOrders.length > 0" class="orders-table">
        <thead>
          <tr>
            <th>Commande #</th>
            <th>Date</th>
            <th>Expédié à</th>
            <th>Total TTC</th>
            <th>Statut</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order) in paginatedOrders" :key="order._id">
            <td>{{ order.orderNumber }}</td>
            <td>{{ formatDate(order.createdAt) }}</td>
            <td>{{ getClientName(order) }}</td>
            <td>{{ typeof order.total === 'number' ? order.total.toFixed(2) + ' MAD' : 'N/A' }}</td>
            <td><span :class="getStatusClass(order.status)">{{ order.status }}</span></td>
            <td><button @click="viewDetails(order)" class="details-btn">Voir détails</button></td>
          </tr>
        </tbody>
      </table>

      <div v-else>Aucune commande trouvée.</div>

      <!-- Pagination -->
      <div class="pagination">
        <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Précédent</button>
        Page {{ currentPage }} / {{ pageCount }}
        <button @click="changePage(currentPage + 1)" :disabled="currentPage === pageCount">Suivant</button>
      </div>
    </div>

    <!-- Modal détails -->
    <div v-if="selectedOrder" class="order-modal">
      <h3>Détails de la commande</h3>
      <p><strong>Commande :</strong> {{ selectedOrder.orderNumber }}</p>
      <p><strong>Statut :</strong> <span :class="getStatusClass(selectedOrder.status)">{{ selectedOrder.status }}</span></p>
      <p><strong>Adresse d’expédition :</strong> {{ selectedOrder.selectedAddress.firstName }} {{ selectedOrder.selectedAddress.lastName }}, {{ selectedOrder.selectedAddress.address }}</p>

      <h4>Produits :</h4>
      <ul>
        <li v-for="(item, i) in selectedOrder.items" :key="i">
          {{ item.name }} — {{ item.quantity }} x {{ item.price.toFixed(2) }} MAD
        </li>
      </ul>

      <p><strong>Total : </strong>{{ selectedOrder.total.toFixed(2) }} MAD</p>
      <button @click="selectedOrder = null" class="close-btn">Fermer</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderStatus",
  data() {
    return {
      loading: true,
      orders: [],
      selectedOrder: null,
      selectedStatus: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredOrders() {
      return this.selectedStatus
        ? this.orders.filter((o) => o.status === this.selectedStatus)
        : this.orders;
    },
    paginatedOrders() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredOrders.slice(start, end);
    },
    pageCount() {
      return Math.ceil(this.filteredOrders.length / this.itemsPerPage);
    },
  },
  methods: {
    getClientName(order) {
      const address = order.selectedAddress;
      return address ? `${address.firstName} ${address.lastName}` : 'N/A';
    },
    getStatusClass(status) {
      switch (status) {
        case 'En attente': return 'badge badge-gray';
        case 'Confirmée': return 'badge badge-blue';
        case 'Préparée': return 'badge badge-orange';
        case 'Expédiée': return 'badge badge-purple';
        case 'Livrée': return 'badge badge-green';
        default: return 'badge';
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    viewDetails(order) {
      this.selectedOrder = order;
    },
    changePage(page) {
      if (page >= 1 && page <= this.pageCount) {
        this.currentPage = page;
      }
    }
  },
  async mounted() {
    const justOrdered = sessionStorage.getItem("justOrdered");
    if (justOrdered) {
      sessionStorage.removeItem("justOrdered");
      location.reload();
    }
    try {
        const userString = sessionStorage.getItem("user");
      const token = sessionStorage.getItem("token");
      if (!userString || !token) {
        this.$router.push("/orderStatus");
        return;
      }
      const user = JSON.parse(userString);
      const response = await fetch(`http://localhost:2028/api/orders/user/${user._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      this.orders = Array.isArray(data) ? data : [];
    } catch (error) {
      console.error("Erreur de chargement des commandes :", error);
    } finally {
      this.loading = false;
    }
  },
  beforeRouteEnter(to, from, next) {
     const user = sessionStorage.getItem('user');
    const token = sessionStorage.getItem('token');
    if (!user || !token) {
      sessionStorage.setItem('redirectAfterLogin', '/orderStatus');
      next('/connexion');
    } else {
      next();
    }
  }
};
</script>

<style scoped>
/* Mode clair par défaut */
.order-status-page {
  padding: 20px;
  max-width: 1000px;
  margin: auto;
  font-family: Arial, sans-serif;
  color: #333;
  background-color: #fff;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

.orders-table th,
.orders-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.orders-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #333;
}

.filter-section {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  align-items: center;
}

.status-filter {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.badge {
  padding: 4px 10px;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 0.85em;
  display: inline-block;
  min-width: 80px;
  text-align: center;
}

.badge-gray { background-color: #6c757d; }
.badge-blue { background-color: #007bff; }
.badge-orange { background-color: #fd7e14; }
.badge-purple { background-color: #6f42c1; }
.badge-green { background-color: #28a745; }

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 12px;
}

.pagination button {
  padding: 8px 16px;
  background: #00998b;
  border: none;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.pagination button:hover {
  background: #007f75;
}

.pagination button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.details-btn,
.close-btn {
  padding: 6px 12px;
  background-color: #00998b;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.details-btn:hover,
.close-btn:hover {
  background-color: #007f75;
}

.order-modal {
  margin-top: 30px;
  background: #fdfdfd;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.orders-table th,
.orders-table td {
  font-size: 14px;
  padding: 10px;
}

.details-btn,
.close-btn,
.pagination button {
  padding: 6px 10px;
  font-size: 14px;
}

.order-status-page {
  padding: 10px;
}

h1 {
  font-size: 22px;
  text-align: center;
}

/*MODE SOMBRE (automatique ou via .dark-mode) */
@media (prefers-color-scheme: dark) {
  .order-status-page {
    background-color: #121212;
    color: #e0e0e0;
  }

  .orders-table {
    background: #1e1e1e;
    border-color: #333;
    box-shadow: 0 2px 8px rgba(255, 255, 255, 0.05);
  }

  .orders-table th,
  .orders-table td {
    border: 1px solid #333;
    color: #e0e0e0;
  }

  .orders-table th {
    background-color: #2a2a2a;
    color: #f1f1f1;
  }

  .filter-section {
    color: #e0e0e0;
  }

  .status-filter {
    background-color: #1e1e1e;
    border: 1px solid #444;
    color: #f1f1f1;
  }

  .pagination button {
    background: #00bfa5;
  }

  .pagination button:hover {
    background: #00998b;
  }

  .pagination button:disabled {
    background: #555;
  }

  .details-btn,
  .close-btn {
    background-color: #00bfa5;
  }

  .details-btn:hover,
  .close-btn:hover {
    background-color: #00998b;
  }

  .order-modal {
    background: #1e1e1e;
    border: 1px solid #444;
    box-shadow: 0 4px 12px rgba(255, 255, 255, 0.05);
  }
}

/* 🌗 Mode sombre forcé via une classe */
.dark-mode .order-status-page {
  background-color: #121212;
  color: #e0e0e0;
}

.dark-mode .orders-table {
  background: #1e1e1e;
  border-color: #333;
}

.dark-mode .orders-table th,
.dark-mode .orders-table td {
  border: 1px solid #333;
  color: #e0e0e0;
}

.dark-mode .orders-table th {
  background-color: #2a2a2a;
  color: #f1f1f1;
}

.dark-mode .status-filter {
  background-color: #1e1e1e;
  border: 1px solid #444;
  color: #f1f1f1;
}

.dark-mode .pagination button {
  background: #00bfa5;
}

.dark-mode .pagination button:hover {
  background: #00998b;
}

.dark-mode .details-btn,
.dark-mode .close-btn {
  background-color: #00bfa5;
}

.dark-mode .details-btn:hover,
.dark-mode .close-btn:hover {
  background-color: #00998b;
}

.dark-mode .order-modal {
  background: #1e1e1e;
  border: 1px solid #444;
}

/*Responsive styles pour tablettes et mobiles */
@media (max-width: 1024px) {
  .order-status-page {
    padding: 15px;
  }

  .orders-table th,
  .orders-table td {
    font-size: 13px;
    padding: 8px;
  }

  .badge {
    font-size: 0.8em;
    padding: 4px 8px;
    min-width: unset;
  }

  .pagination {
    flex-wrap: wrap;
    gap: 10px;
  }
}

@media (max-width: 450px) {
  .order-status-page {
    padding: 10px;
  }

  .orders-table {
    display: block;
    overflow-x: auto;
    box-shadow: none;
    border-radius: 0;
  }

  .orders-table th,
  .orders-table td {
    font-size: 12px;
    padding: 6px;
  }

  .details-btn,
  .close-btn,
  .pagination button {
    font-size: 12px;
    padding: 6px 8px;
  }

  h1 {
    font-size: 20px;
  }

  .badge {
    font-size: 0.75em;
    padding: 3px 6px;
  }
}
</style>

